export type Article = {
  id: string;
  title: string;
  category: string;
  cover: string;
  coverAlt: string;
  summary: string;
  author: string;
  date: string;
  readMinutes: number;
  views: number;
  heat: number;
  tags: string[];
  lead: string;
  paragraphs: string[];
};

export const ARTICLES: Article[] = [
  {
    id: "a1",
    title: "古装剧《长风入夜》为何一开播就刷屏？三个看点帮你快速看懂",
    category: "yingshi",
    cover:
      "https://readdy.ai/api/search-image?query=cinematic%20ancient%20chinese%20period%20drama%20still%20scene%20with%20flowing%20robes%20lanterns%20and%20warm%20golden%20glow%2C%20editorial%20entertainment%20magazine%20photography%2C%20rich%20cinematic%20lighting%2C%20warm%20amber%20and%20ink%20tones%2C%20high%20detail%20composition&width=900&height=620&seq=chi-cvr-01&orientation=landscape",
    coverAlt: "古装剧《长风入夜》剧集画面",
    summary:
      "作为本周话题度最高的古装新剧，《长风入夜》凭借扎实的服化道与节奏明快的叙事，在上线当天就冲进了多个平台的热门榜单。",
    author: "追剧小西瓜",
    date: "今日 09:20",
    readMinutes: 5,
    views: 128600,
    heat: 96,
    tags: ["古装剧", "新剧热播", "口碑盘点"],
    lead: "《长风入夜》上线首周，讨论声量一路走高，从服化道细节到剧情走向都在热搜上反复出现。如果你还没来得及追，可以从这三点先了解它为什么会火。",
    paragraphs: [
      "第一，是“看得见成本”的制作质感。无论是街景的烟火气，还是宫廷场景的冷暖光影，剧组在美术与摄影上给足了信息量，让观众一眼就能沉浸进去，而不是停留在“古装等于好看就行”的旧印象里。",
      "第二，是角色关系的松弛感。主角团并没有一上来就剑拔弩张，而是先靠日常互动把人物立住，再逐步推进冲突。这种节奏更贴近当下观众的追剧习惯，也更容易让人产生“想一口气看完”的追更感。",
      "第三，是讨论场的搭建。剧方配合播出节奏释出的幕后花絮与角色彩蛋，为二创和剧情解析提供了大量素材，从平台热搜到短视频切片，都持续保持着较高的话题活跃度。",
      "综合来看，这部剧走的是一条“稳扎稳打再放大”的路子。后续剧情若能保持前几集的水准，热度大概率还会继续发酵，值得列入你的追剧清单。",
    ],
  },
  {
    id: "a2",
    title: "暑期电影档收官盘点：喜剧与动画为何成为今年的大赢家",
    category: "yingshi",
    cover:
      "https://readdy.ai/api/search-image?query=stylish%20cinema%20movie%20poster%20collage%20with%20popcorn%20and%20film%20reel%20in%20warm%20neon%20light%2C%20editorial%20entertainment%20feature%20illustration%2C%20vibrant%20coral%20and%20amber%20palette%2C%20modern%20graphic%20design%20composition&width=900&height=620&seq=chi-cvr-02&orientation=landscape",
    coverAlt: "暑期电影档票房盘点",
    summary:
      "今年暑期档在类型分布上呈现出明显变化：合家欢喜剧与高品质动画持续领跑，题材差异化成为内容竞争的关键词。",
    author: "影院情报站",
    date: "今日 08:45",
    readMinutes: 6,
    views: 98000,
    heat: 88,
    tags: ["电影", "暑期档", "票房观察"],
    lead: "暑期档进入尾声，回头看这一季的票房分布，喜剧与动画两大类型表现相当亮眼，背后是内容供给与观众选择的双向变化。",
    paragraphs: [
      "从观众画像来看，今年暑期“结伴观影”和“亲子观影”的比例明显提高。轻松解压的喜剧和内容友善的动画，天然契合多人出行的观影需求，也因此在口碑与票房间形成了更强的正循环。",
      "另一方面，档期内并未出现“一枝独秀”的绝对头部，反而呈现出多部影片分庭抗礼的格局。题材差异化、观众细分化的趋势，让更多中等体量的优质作品获得了出圈机会。",
      "有业内人士分析，这一现象背后是内容审美的成熟：观众不再只看阵容或营销，而更在意作品本身能否提供稳定的情绪价值与讨论空间。对片方而言，回归内容本身正成为最具确定性的选择。",
    ],
  },
  {
    id: "a3",
    title: "口碑黑马盘点：三部小成本网剧凭什么让观众自发安利",
    category: "yingshi",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20film%20set%20behind%20the%20scenes%20with%20director%20monitor%20and%20warm%20studio%20lights%2C%20editorial%20feature%20photography%2C%20documentary%20style%2C%20warm%20amber%20and%20charcoal%20tones%2C%20soft%20bokeh%20depth&width=900&height=620&seq=chi-cvr-03&orientation=landscape",
    coverAlt: "小成本网剧口碑黑马",
    summary:
      "在头部大剧之外，一批小成本网剧凭紧凑叙事与真实质感成为口碑黑马，让“小而美”成为当下剧集市场的新关键词。",
    author: "追剧小西瓜",
    date: "昨日 22:10",
    readMinutes: 4,
    views: 76000,
    heat: 82,
    tags: ["网剧", "口碑黑马", "小而美"],
    lead: "当大制作还在拼阵容与场面时，几部小成本网剧已经靠扎实的叙事悄悄出圈。它们证明：好内容不一定需要大预算。",
    paragraphs: [
      "本轮被反复安利的几部作品，共同点都很鲜明：剧本扎实、节奏紧凑、角色真实。没有注水的支线，每一集都有明确推进，让观众看得“上头”又舍不得倍速。",
      "在演员选择上，它们更看重贴合度而非流量，主演表现反而成为加分项，频频出现在观众的“演技讨论”里，形成了口碑的自然扩散。",
      "业内观点认为，这类作品的出现为内容市场释放了积极信号——当观众愿意为真诚与用心买单，创作者的创作空间也会随之拓宽，“小而美”的未来值得期待。",
    ],
  },
  {
    id: "a4",
    title: "全新户外闯关综艺首播：真实感与高能名场面并存",
    category: "zongyi",
    cover:
      "https://readdy.ai/api/search-image?query=energetic%20outdoor%20adventure%20variety%20show%20stage%20with%20bright%20obstacle%20course%20and%20sunlight%2C%20playful%20entertainment%20photography%2C%20fresh%20warm%20tones%2C%20dynamic%20editorial%20composition&width=900&height=620&seq=chi-cvr-04&orientation=landscape",
    coverAlt: "户外闯关综艺首播现场",
    summary:
      "一档全新的户外闯关综艺在周末首播，真实到位的规则设计与嘉宾间的默契配合，让“名场面”几乎一期一个地刷屏短视频。",
    author: "综艺观察员",
    date: "今日 11:05",
    readMinutes: 5,
    views: 110300,
    heat: 92,
    tags: ["综艺首播", "户外闯关", "名场面"],
    lead: "本周末上线的户外闯关综艺，凭借清爽的赛制和真实的临场反应，在首播当天就贡献了多个讨论度极高的名场面。",
    paragraphs: [
      "节目最大的亮点在于“不确定性”：难度适中的闯关环节留足了发挥空间，嘉宾面对突发状况时的真实反应，往往比提前设计的台本更有看点，也让观众产生了强烈的代入感。",
      "嘉宾之间的配合默契同样功不可没。无论是互相鼓励还是互相“拆台”，自然流露的互动让节目氛围轻松又热闹，被不少网友评价为“看完心情都会变好”。",
      "从首播数据看，节目的年轻观众占比很高，二创与剪辑传播也相当活跃。只要后续赛制能持续制造新鲜感，这档节目大概率会成为近期热议的常客。",
    ],
  },
  {
    id: "a5",
    title: "歌唱竞演综艺回归：从“飙高音”到“讲好一个故事”",
    category: "zongyi",
    cover:
      "https://readdy.ai/api/search-image?query=concert%20stage%20with%20warm%20spotlight%20and%20microphone%20silhouette%2C%20editorial%20music%20magazine%20photography%2C%20dramatic%20warm%20golden%20backlight%2C%20atmospheric%20and%20cinematic%2C%20high%20contrast%20composition&width=900&height=620&seq=chi-cvr-05&orientation=landscape",
    coverAlt: "歌唱竞演综艺舞台",
    summary:
      "老牌歌唱竞演综艺回归新一季，观众的评审标准正从单纯的“飙高音”转向“如何用声音讲好一个故事”。",
    author: "音乐雷达",
    date: "昨日 20:30",
    readMinutes: 5,
    views: 89000,
    heat: 86,
    tags: ["竞演综艺", "音乐现场", "新一季"],
    lead: "新一季歌唱竞演节目播出后，一个明显的变化是：观众对“唱得好”的理解，正在从技巧参数转向情感表达。",
    paragraphs: [
      "节目组本季在选曲与编曲上下足功夫，鼓励选手打破舒适区，用更贴近个人经历的方式诠释歌曲。不少舞台因此呈现出“技术让位于叙事”的新质感，获得现场与线上的一致好评。",
      "对选手而言，这既是机会也是挑战：打动人心远比稳定炫技更难。但也正因如此，能真正“把歌唱进心里”的舞台，往往能收获远超预期的讨论与共鸣。",
      "业内人士认为，这种审美转向对整个行业是好事。当情感与表达被放在首位，好作品与好声音的衡量标准会更加多元，也会倒逼创作回归内容本质。",
    ],
  },
  {
    id: "a6",
    title: "慢综艺治愈系盘点：忙碌生活里，观众在找什么？",
    category: "zongyi",
    cover:
      "https://readdy.ai/api/search-image?query=cozy%20slow%20variety%20show%20scene%20with%20friends%20cooking%20by%20cottage%20window%20warm%20evening%20light%2C%20soothing%20editorial%20photography%2C%20soft%20cream%20and%20amber%20palette%2C%20heartwarming%20atmosphere&width=900&height=620&seq=chi-cvr-06&orientation=landscape",
    coverAlt: "治愈系慢综艺场景",
    summary:
      "从做饭聊天到乡野旅行，治愈系慢综艺持续圈粉。在快节奏的当下，观众需要的不只是内容，更是一种情绪的缓冲地带。",
    author: "综艺观察员",
    date: "昨日 18:00",
    readMinutes: 4,
    views: 67000,
    heat: 79,
    tags: ["慢综艺", "治愈系", "情绪价值"],
    lead: "如果说竞演类综艺提供的是刺激，那慢综艺提供的则是难得的松弛。它正在成为很多观众下班后的“电子安抚”。",
    paragraphs: [
      "这类节目的共同特征，是刻意放慢节奏、减少对抗性，把镜头对准日常相处的细节。一顿饭、一次散步、一句随口而出的闲聊，都能成为治愈的支点。",
      "观众愿意为这份“慢”买单，背后是真实的情感需求：在高强度的工作与社交之后，人们渴望一段不用带脑子的陪伴式内容，让情绪得到缓释。",
      "从市场表现看，慢综艺的受众黏性普遍较高，忠实观众甚至会二刷三刷。只要节目能守住“真诚不做作”的底线，治愈赛道的长期价值依然可观。",
    ],
  },
  {
    id: "a7",
    title: "本季红毯造型盘点：谁的礼服既稳又敢，成了热议焦点",
    category: "mingxing",
    cover:
      "https://readdy.ai/api/search-image?query=glamorous%20red%20carpet%20fashion%20gown%20in%20warm%20evening%20lights%20with%20fabric%20detail%2C%20editorial%20fashion%20magazine%20photography%2C%20elegant%20coral%20and%20champagne%20tones%2C%20luxury%20refined%20composition&width=900&height=620&seq=chi-cvr-07&orientation=landscape",
    coverAlt: "红毯礼服造型",
    summary:
      "本季几场重要活动陆续举行，红毯造型再度成为热搜常客。比起一味求稳，那些在设计与配色上“敢表达”的造型更受讨论欢迎。",
    author: "造型速递员",
    date: "今日 10:30",
    readMinutes: 4,
    views: 102000,
    heat: 90,
    tags: ["红毯", "造型盘点", "时尚话题"],
    lead: "红毯从来不只是衣着的展示，更是风格与态度的表达。本季多场活动中，一批“又稳又敢”的造型成为讨论焦点。",
    paragraphs: [
      "细看被讨论最多的几套造型，它们的共同点并非足够夸张，而是足够“自洽”：礼服的设计语言与穿着者的气质相互成全，让整体观感高级而不生硬。",
      "在配色与剪裁上，今年明显能看到从“安全牌”向“个性表达”的倾斜。设计师与艺人团队更愿意尝试有记忆点的元素，让造型在合照之外也能单独“站得住”。",
      "造型讨论的火热，也反映出时尚审美的成熟。观众评判一套红毯造型时，越来越多地从“好不好看”走向“适不适合、有没有想法”，这对整个行业的审美进步是一种良性推动。",
    ],
  },
  {
    id: "a8",
    title: "新一轮巡演资讯速递：场馆、曲目与抢票时间一次看清",
    category: "mingxing",
    cover:
      "https://readdy.ai/api/search-image?query=large%20concert%20tour%20crowd%20with%20warm%20light%20sticks%20and%20stage%20silhouette%2C%20editorial%20event%20photography%2C%20vibrant%20warm%20night%20tones%2C%20energy%20and%20scale%20composition&width=900&height=620&seq=chi-cvr-08&orientation=landscape",
    coverAlt: "演唱会巡演现场",
    summary:
      "近期多位歌手的巡演计划陆续官宣。本文整理公开的场馆、场次与开票节奏，帮你提前做好抢票攻略。",
    author: "音乐雷达",
    date: "昨日 15:20",
    readMinutes: 5,
    views: 94000,
    heat: 85,
    tags: ["巡演", "抢票攻略", "现场演出"],
    lead: "演出市场持续火热，新一轮巡演官宣让不少乐迷摩拳擦掌。这里把已经公开的演出信息梳理成了一份实用攻略。",
    paragraphs: [
      "从已公布的档期看，本轮巡演覆盖城市较广，且场地规模从体育馆到万人场不等，不同预算与需求的观众都能找到合适的观演方案。",
      "在曲目安排上，多位歌手表示会兼顾经典与新作，部分场次还设置了城市限定曲目，成为乐迷“刷多场”的额外动力。",
      "需要提醒的是，热门场次的开票竞争向来激烈，建议提前完成实名与支付信息绑定，并留意正式开票时间，避免错过。理性购票、量力而行，才能享受一场真正放松的现场。",
    ],
  },
  {
    id: "a9",
    title: "新生代音乐人观察：多元风格与创作表达正在双向奔赴",
    category: "yinyue",
    cover:
      "https://readdy.ai/api/search-image?query=young%20musician%20recording%20in%20warm%20studio%20with%20keyboard%20and%20headphones%2C%20editorial%20music%20portrait%20photography%2C%20soft%20amber%20window%20light%2C%20authentic%20and%20warm%20composition&width=900&height=620&seq=chi-cvr-09&orientation=landscape",
    coverAlt: "新生代音乐人创作现场",
    summary:
      "当审美趋于多元，新生代音乐人正用风格融合与真实表达打开新空间，也让“什么是好音乐”有了更多元的答案。",
    author: "乐评现场",
    date: "昨日 12:40",
    readMinutes: 5,
    views: 61000,
    heat: 78,
    tags: ["音乐人", "风格融合", "华语乐坛"],
    lead: "在算法与分众的双重影响下，新生代音乐人的创作版图正变得更加多元，也更具个人辨识度。",
    paragraphs: [
      "近年来，民谣、电子、说唱、国风等风格的边界不断被打破，“融合”成为高频词。一批年轻创作者把生活观察写进词曲，用更贴近时代的语感获得年轻听众的共鸣。",
      "与此同时，短视频平台为作品的冷启动提供了便利，一首歌的走红路径变得更加难以预测，但也让真正有巧思的表达有了更多被听见的机会。",
      "业内人士提醒，流量之外，持续的创作能力仍是立身之本。风格可以多元，但扎实的创作内核，才是让听众愿意长期跟随的关键。",
    ],
  },
  {
    id: "a10",
    title: "本周热搜关键词复盘：剧集霸榜、综艺出圈与全网热梗一个不少",
    category: "redian",
    cover:
      "https://readdy.ai/api/search-image?query=modern%20social%20media%20trending%20keywords%20floating%20on%20warm%20orange%20gradient%20background%20with%20light%20glass%20texture%2C%20editorial%20tech%20illustration%2C%20minimal%20warm%20composition&width=900&height=620&seq=chi-cvr-10&orientation=landscape",
    coverAlt: "本周热搜关键词回顾",
    summary:
      "一周热门话题落幕，剧集爆款、综艺名场面与网络热梗轮番刷屏。跟随这份复盘，一次看懂大家本周都在聊什么。",
    author: "热点捕手",
    date: "今日 07:50",
    readMinutes: 4,
    views: 132000,
    heat: 98,
    tags: ["热搜复盘", "网络热梗", "全网热议"],
    lead: "过去一周的热搜榜相当热闹。既有剧集与综艺贡献的长期霸榜，也有来去匆匆的趣味热梗，共同构成了这周的公共记忆。",
    paragraphs: [
      "在内容侧，古装新剧的播出持续带火相关讨论，从角色到剧情都衍生出大量二创；周末的综艺名场面则贡献了短视频平台的多条高播放切片，形成跨平台传播。",
      "在话题侧，“松弛感”“先破防再和解”等词频频出现，折射出网友情绪表达的新方式——大家越来越喜欢用轻松、自嘲的口吻来回应生活的起伏。",
      "值得注意的是，本周多条热搜呈现出“内容即话题”的特征：由优质作品自然带起的讨论，往往比刻意营销更有生命力，也更容易沉淀为长期口碑。",
    ],
  },
  {
    id: "a11",
    title: "2026 网络热梗小词典：看懂这些词，跟上大家的聊天节奏",
    category: "redian",
    cover:
      "https://readdy.ai/api/search-image?query=playful%20speech%20bubbles%20and%20chat%20stickers%20floating%20on%20warm%20cream%20background%2C%20fun%20editorial%20illustration%2C%20coral%20and%20mustard%20color%20palette%2C%20lighthearted%20modern%20composition&width=900&height=620&seq=chi-cvr-11&orientation=landscape",
    coverAlt: "网络热梗科普小词典",
    summary:
      "网络热梗更新速度飞快，跟不上聊天节奏是很多人的困扰。这里挑选近期高频热词，用接地气的解释帮你快速入门。",
    author: "热点捕手",
    date: "昨日 21:00",
    readMinutes: 5,
    views: 84000,
    heat: 84,
    tags: ["热梗", "网络流行语", "科普"],
    lead: "热梗是网络社交的“共同语言”，可它们来得快去得也快。我们把近期讨论度较高的几个词整理成一本“速查小词典”。",
    paragraphs: [
      "理解热梗的关键，不在于背下定义，而在于场景。很多词是特定情境下的情绪放大镜，用在合适的语境里才显生动。本文在解释含义之外，也尽量还原了它们的使用场景。",
      "需要注意的是，热梗具有很强的时效性，同一词汇在不同时期、不同圈子里的含义也可能发生偏移。阅读时不妨结合上下文，避免“过时使用”带来的小尴尬。",
      "说到底，热梗是人与人轻松交流的载体。与其焦虑追赶，不如把它当作观察年轻人表达习惯的一扇窗，轻松看待、适度使用即可。",
    ],
  },
  {
    id: "a12",
    title: "音乐节密集回归：阵容官宣、交通攻略与现场避坑指南",
    category: "yinyue",
    cover:
      "https://readdy.ai/api/search-image?query=open%20air%20music%20festival%20crowd%20at%20golden%20hour%20with%20main%20stage%20silhouette%20and%20flags%2C%20editorial%20festival%20photography%2C%20warm%20sunset%20tones%2C%20joyful%20vibrant%20composition&width=900&height=620&seq=chi-cvr-12&orientation=landscape",
    coverAlt: "户外音乐节现场",
    summary:
      "这个秋天音乐节密集回归，多场阵容陆续官宣。收藏这份交通与现场攻略，让观演体验更顺畅、更尽兴。",
    author: "乐评现场",
    date: "今日 06:30",
    readMinutes: 6,
    views: 70000,
    heat: 81,
    tags: ["音乐节", "现场攻略", "秋季演出"],
    lead: "随着天气转凉，一批户外音乐节先后官宣。如何选场、怎么去、带什么，成了乐迷们最近讨论最多的话题。",
    paragraphs: [
      "从已公开的阵容看，本季音乐节在音乐类型上覆盖广泛，既有头部艺人压轴，也保留了大量新锐音乐人的展演时段，对“挑演出”的观众相当友好。",
      "出行层面，多场活动选择了具备接驳条件的场地，主办方通常会提前公布官方交通方案。建议优先选择公共接驳，并错峰入场，能省去不少现场排队的精力。",
      "现场体验方面，防晒补水、便携坐垫、备好随身充电设备是基本功课；同时提前看好各舞台的演出时间，合理规划路线，才能不错过想看的时段。祝大家都能在音乐里好好放松一场。",
    ],
  },
];